import { ref } from 'vue';

// Global toast state
const toasts = ref([]);
let toastIdCounter = 0;

// Toast configuration defaults
const defaultOptions = {
  type: 'success',
  duration: 5000,
  persistent: false
};

export function useToast() {

  /**
   * Add a new toast notification
   */
  function addToast(message, options = {}) {
    const id = `toast-${++toastIdCounter}`;
    const config = { ...defaultOptions, ...options };

    const toast = {
      id,
      message,
      ...config
    };

    toasts.value.push(toast);

    return id;
  }

  /**
   * Remove a toast by ID
   */
  function removeToast(id) {
    const index = toasts.value.findIndex(toast => toast.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  }

  /**
   * Clear all toasts
   */
  function clearToasts() {
    toasts.value = [];
  }

  /**
   * Add a success toast
   */
  function success(message, options = {}) {
    return addToast(message, { ...options, type: 'success' });
  }

  /**
   * Add an error toast
   */
  function error(message, options = {}) {
    return addToast(message, { ...options, type: 'error', duration: 7000 });
  }

  /**
   * Add a warning toast
   */
  function warning(message, options = {}) {
    return addToast(message, { ...options, type: 'warning', duration: 6000 });
  }

  /**
   * Add an info toast
   */
  function info(message, options = {}) {
    return addToast(message, { ...options, type: 'info' });
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearToasts,
    success,
    error,
    warning,
    info
  };
}
